import { FileExport, PartialBlob } from "../types";
import {
  deleteBlobs,
  getFileBlob,
  rehydrateBlobs,
} from "../services/file-explorer-service";

export const handleDeleteFiles = async (
  blobs: PartialBlob[],
): Promise<void> => {
  await deleteBlobs(blobs);
};

export const handleRehydrateFiles = async (
  blobs: PartialBlob[],
): Promise<void> => {
  await rehydrateBlobs(blobs);
};

const decodeBase64ToBlob = (fileData: string): Blob => {
  const byteCharacters = atob(fileData);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.codePointAt(i) ?? 0;
  }
  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], { type: "application/octet-stream" });
};

export const handleDownloadFile = async (blob: PartialBlob): Promise<void> => {
  const fileExport: FileExport = await getFileBlob(blob);

  const fileBlob = decodeBase64ToBlob(fileExport.fileData);

  const url = globalThis.URL.createObjectURL(fileBlob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileExport.fileName || blob.name;
  document.body.appendChild(link);
  link.click();

  link.remove();
  globalThis.URL.revokeObjectURL(url);
};
